export type SessionType = 'ephemeral' | 'persistent';

export const authStorage = {
    getToken: (): string | null => {
        return sessionStorage.getItem('token') || localStorage.getItem('token') || localStorage.getItem('pos_token');
    },
    getUser: (): string | null => {
        return sessionStorage.getItem('user') || localStorage.getItem('user') || localStorage.getItem('pos_user');
    },
    getSessionType: (): SessionType | null => {
        return (sessionStorage.getItem('session_type') || localStorage.getItem('session_type')) as SessionType | null;
    },

    setAuth(token: string, user: string, type: SessionType) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user', user);
        sessionStorage.setItem('session_type', type);

        // Also persist in localStorage so new tabs (KDS, Display, Kitchen) have valid authentication
        localStorage.setItem('token', token);
        localStorage.setItem('user', user);
        localStorage.setItem('session_type', type);
        localStorage.setItem('pos_token', token);
        localStorage.setItem('pos_user', user);
    },
    setUser: (user: string) => {
        sessionStorage.setItem('user', user);
        localStorage.setItem('user', user);
        localStorage.setItem('pos_user', user);
    },

    clearCurrentTab() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('session_type');
    },
};
